import axios from 'axios';
import { Message } from 'element-ui';
import router from '@/router/index'

const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json',
    }
});

// 请求拦截器
request.interceptors.request.use(

    config => {
        // 在发送请求之前做些什么，比如添加token
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = token;
        }
        if (!config.data) {
            config.data = {}
        }
        if (config.url.indexOf('upload/singleUpload') !== -1) {
            config.headers["Content-Type"] = "multipart/form-data";
        } else {
            config.headers["Content-Type"] = "application/json";
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code !== 200) {
            Message({
                message: res.msg,
                type: 'error'
            })
        }
        return res;
    },
    error => {
        console.log('请求报错:', error.response)
        // 对响应错误做点什么
        if (error.response.status === 401) {
            // 处理未授权
            localStorage.setItem("token", "");
            Message({ message: 'token已过期', type: 'error' })
            router.push('/login');

        }
        return Promise.reject(error);
    }
);

export default request;